import CheckGray from '../assets/icons/check-gray.svg'
import { ReactComponent as Next } from '../assets/icons/next.svg'
import { ReactComponent as Prev } from '../assets/icons/prev.svg'
import { ReactComponent as Delete } from '../assets/icons/delete.svg'
import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { ReactComponent as CheckMark } from '../assets/icons/checkmark.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useEffect, useState } from 'react'
import { DeleteModal } from '../components/Modal'
import { deleteCourses, getCoursesCoverInfo, putCourses } from '../apis/course.ts'

export default function ClassUpdate() {
  const location = useLocation()
  const navigate = useNavigate()
  const [coverInfoList, setCoverInfoList] = useState()
  const [selectedCoverInfo, setSelectedCoverInfo] = useState({
    imageId: location.state.data.image.imageId,
    colorId: location.state.data.image.colorId,
  })
  const sortedByList = [
    { id: 1, name: '기본교과', type: 'basicImage' },
    { id: 2, name: '전공', type: 'majorImage' },
  ]
  const [sortedBy, setSortedBy] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      className: location.state.data.className,
      imageId: location.state.data.image.imageId,
      colorId: location.state.data.image.colorId,
    },
  })

  useEffect(() => {
    getCoursesCoverInfoApi()
  }, [])

  const findItem = (list, id) => {
    const item = list?.find((item) => item.id === id)
    return item
  }

  useEffect(() => {
    if (Boolean(findItem(coverInfoList?.images['basicImage'], location.state.data.image.imageId))) {
      setSortedBy(1)
      if (
        coverInfoList?.images['basicImage'].findIndex(
          (item) => item.id === location.state.data.image.imageId,
        ) +
          1 >
        6
      ) {
        setCurrentPage(2)
      } else {
        setCurrentPage(1)
      }
    }
    if (Boolean(findItem(coverInfoList?.images['majorImage'], location.state.data.image.imageId))) {
      setSortedBy(2)
      setCurrentPage(1)
    }
    // eslint-disable-next-line
  }, [coverInfoList])

  const onSubmit = async (data) => {
    // console.log(data)
    if (location.state.data.className === data.className) {
      const putCoursesResponse = await putCourses(
        {
          courseId: location.state.data.id,
        },
        {
          imageId: selectedCoverInfo.imageId
            ? selectedCoverInfo.imageId
            : location.state.data.image.imageId,
          colorId: selectedCoverInfo.colorId
            ? selectedCoverInfo.colorId
            : location.state.data.image.colorId,
        },
      )
      if (putCoursesResponse.error) {
        console.log(putCoursesResponse.message)
        if (putCoursesResponse.error.code === 'E409') {
          setError('className', {
            message:
              '해당 학기의 동일 교과 - 과목 수업에 대해 같은 이름의 분반이 있습니다. 다른 이름으로 설정해주세요.',
          })
        }
        return
      } else {
        console.log(putCoursesResponse.result)
        navigate('/class/detail', { state: { updatedData: data, data: location.state.data } })
      }
    } else {
      const putCoursesResponse = await putCourses(
        {
          courseId: location.state.data.id,
        },
        {
          className: data.className,
          imageId: selectedCoverInfo.imageId
            ? selectedCoverInfo.imageId
            : location.state.data.image.imageId,
          colorId: selectedCoverInfo.colorId
            ? selectedCoverInfo.colorId
            : location.state.data.image.colorId,
        },
      )
      if (putCoursesResponse.error) {
        console.log(putCoursesResponse.message)
        if (putCoursesResponse.error.code === 'E409') {
          setError('className', {
            message:
              '해당 학기의 동일 교과 - 과목 수업에 대해 같은 이름의 분반이 있습니다. 다른 이름으로 설정해주세요.',
          })
        }
        return
      } else {
        console.log(putCoursesResponse.result)
        navigate('/class/detail', { state: { updatedData: data, data: location.state.data } })
      }
    }
  }

  const getCoursesCoverInfoApi = async () => {
    const getCoursesCoverInfoResponse = await getCoursesCoverInfo()

    if (getCoursesCoverInfoResponse.error) {
      console.log(getCoursesCoverInfoResponse)
      return
    } else {
      setCoverInfoList(getCoursesCoverInfoResponse.data)
    }
  }

  const deleteCoursesApi = async (courseId) => {
    const deleteCoursesResponse = await deleteCourses({
      courseId: courseId,
    })
    if (deleteCoursesResponse.error) {
      console.log(deleteCoursesResponse.message)
      return
    } else {
      console.log(deleteCoursesResponse.result)
      navigate('/class')
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    if (sortedBy === 2) {
      setCurrentPage(1)
    }
  }, [sortedBy])

  const handleOnInput = (e, maxlength) => {
    const {
      target: { value },
    } = e
    if (value.length > maxlength) e.target.value = value.substr(0, maxlength)
  }

  // const preventClose = (e) => {
  //   e.preventDefault()
  //   // e.returnValue = '' //Chrome에서 동작하도록; deprecated
  // }
  // useEffect(() => {
  //   ;(() => {
  //     window.addEventListener('beforeunload', preventClose)
  //   })()
  //   return () => {
  //     window.removeEventListener('beforeunload', preventClose)
  //   }
  // }, [])

  return (
    <div>
      <div className='mb-40 flex w-full items-center gap-20 border-b-2 border-solid border-border-strong py-8'>
        <p className='text-title2-bold text-label-strong'>수업 정보 수정</p>
        <p className='text-body1-medium text-label-sub'>{location.state.data.semester.name}</p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='flex items-center justify-center'>
          <div className='flex w-[700px] flex-col items-end justify-center gap-60 rounded-16 border-[1px] border-solid border-border-alternative px-20 py-16'>
            <div className='flex w-full flex-col gap-24'>
              <div className='flex flex-col items-start gap-8'>
                <p className='text-body1-medium text-label-default'>분반 이름</p>
                <div className='relative w-full'>
                  <input
                    {...register('className', {
                      required: '분반 이름을 작성해주세요',
                      maxLength: 20,
                    })}
                    type='text'
                    className={`${errors.className ? 'border-status-negative hover:border-status-negative focus:border-status-negative' : ''} input_default w-full`}
                    placeholder='공백 포함 20자 이내'
                    maxLength='20'
                    onInput={(e) => handleOnInput(e, 20)}
                  />
                  <span className='text-body3-regular text-status-negative'>
                    {errors?.className?.message}
                  </span>
                  {watch('className') && (
                    <button
                      type='button'
                      onClick={() => setValue('className', '')}
                      className='absolute right-16 top-16 cursor-pointer'
                    >
                      <CloseFilled />
                    </button>
                  )}
                </div>
              </div>
              {/* 커버이미지 */}
              <div className='flex w-full flex-col items-start gap-8'>
                <p className='text-body1-medium text-label-default'>커버이미지</p>
                <div className='flex w-full flex-col items-start gap-16'>
                  <div
                    className='border_default relative h-[200px] w-full rounded-20'
                    style={{
                      backgroundColor: selectedCoverInfo.backgroundColor
                        ? selectedCoverInfo.backgroundColor
                        : location.state.data.image.backgroundColor,
                    }}
                  >
                    <p className='absolute left-50 top-50 text-title1-bold text-label-default'>
                      {location.state.data.subject.name}
                    </p>
                    <img
                      className='absolute right-60 top-0 h-full w-[280px] mix-blend-overlay'
                      src={
                        selectedCoverInfo.imageUrl
                          ? selectedCoverInfo.imageUrl
                          : location.state.data.image.imageUrl
                      }
                      alt=''
                    />
                  </div>
                  {/* 일러스트 선택 */}
                  <div className='flex w-full flex-col items-start gap-8'>
                    <p className='text-body2-medium text-label-default'>일러스트 선택</p>
                    <div className='flex w-full justify-between'>
                      <div className='flex items-center gap-4'>
                        {sortedByList.map((item) => (
                          <button
                            key={item.id}
                            type='button'
                            onClick={() => setSortedBy(item.id)}
                            className={`${sortedBy === item.id ? 'tag_sm' : 'tag_sm_border'}`}
                          >
                            {item.name}
                          </button>
                        ))}
                      </div>
                      <div className='border_default flex divide-x-[1px] divide-solid divide-border-default rounded-10'>
                        <button
                          type='button'
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          disabled={Boolean(currentPage === 1)}
                          className={`${currentPage === 1 ? 'fill-label-placeholder' : 'fill-label-sub'} flex items-center p-6`}
                        >
                          <Prev />
                        </button>
                        <button
                          type='button'
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          disabled={Boolean(
                            currentPage ===
                              Math.ceil(
                                coverInfoList?.images[
                                  `${sortedBy === 1 ? 'basicImage' : 'majorImage'}`
                                ].length / 6,
                              ),
                          )}
                          className={`${currentPage === Math.ceil(coverInfoList?.images[`${sortedBy === 1 ? 'basicImage' : 'majorImage'}`].length / 6) ? 'fill-label-placeholder' : 'fill-label-sub'} flex items-center p-6`}
                        >
                          <Next />
                        </button>
                      </div>
                    </div>
                    <div className='grid w-full grid-cols-6 items-center gap-8'>
                      {coverInfoList?.images[`${sortedBy === 1 ? 'basicImage' : 'majorImage'}`]
                        .slice((currentPage - 1) * 6, (currentPage - 1) * 6 + 6)
                        .map((imageItem) => (
                          <img
                            key={imageItem.id}
                            onClick={() =>
                              setSelectedCoverInfo((prev) => ({
                                ...prev,
                                imageUrl: imageItem.url,
                                imageId: imageItem.id,
                              }))
                            }
                            className={`object-fit h-[75px] w-100 rounded-8 border-[1px] border-solid px-8 py-[7px] ${imageItem.id === selectedCoverInfo.imageId ? 'border-border-active' : 'border-border-default'}`}
                            src={imageItem.url}
                            alt=''
                          />
                        ))}
                    </div>
                  </div>
                  {/* 배경색 선택 */}
                  <div className='flex w-full flex-col items-start gap-8'>
                    <p className='text-body2-medium text-label-default'>배경색 선택</p>
                    <div className='border_default flex w-full flex-col items-start gap-12 rounded-8 p-12'>
                      <div className='grid grid-cols-6 items-center gap-8'>
                        {coverInfoList?.colors?.map((colorItem, colorIndex) => (
                          <div
                            key={colorIndex}
                            onClick={() =>
                              setSelectedCoverInfo((prev) => ({
                                ...prev,
                                backgroundColor: colorItem.backgroundColor,
                                // textColor: colorItem.textColor,
                                colorId: colorItem.id,
                              }))
                            }
                            className='border_default flex h-48 w-48 items-center justify-center rounded-8 fill-inverse-label'
                            style={{ backgroundColor: colorItem.backgroundColor }}
                          >
                            {colorItem.id === selectedCoverInfo.colorId && (
                              <CheckMark className='h-20 w-20' />
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='flex w-full justify-between'>
              <button
                type='button'
                className='button_outlined_secondary_md gap-[5px] fill-status-negative'
                onClick={openModal}
              >
                <Delete />
                <p className='text-body2-semibold text-status-negative'>삭제</p>
              </button>
              <button type='submit' className='button_solid_primary_md gap-[5px]'>
                <img src={CheckGray} alt='' />
                <p className='text-body2-semibold text-inverse-label'>수정</p>
              </button>
            </div>
          </div>
        </div>
      </form>
      {isModalOpen && (
        <DeleteModal
          close={closeModal}
          content={'class'}
          deleteApi={() => deleteCoursesApi(location.state.data.id)}
          onStateChange={closeModal}
        />
      )}
    </div>
  )
}
